import styled from 'styled-components';

export const StyledAnswerFeedback = styled.div`
  pointer-events: none;
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  .feedback-icon {
    font-size: 140%;
    font-weight: bold;
  }
`;
